import pluralize from 'pluralize';
import { memo } from 'react';

import { DropdownMenuLabel } from '@air/primitive-dropdown-menu';

import { BOARDLESS_LOCATION_NAME } from '~/components/v2/components/shared/selectionBar/consts';
import { type FlatListItem } from '~/components/v2/components/shared/selectionBar/types';

export type SelectedItemGroupHeaderProps = {
  listItem?: FlatListItem;
};

export const SelectedItemGroupHeader = memo(({ listItem }: SelectedItemGroupHeaderProps) => {
  if (!listItem || listItem.type !== 'header') {
    return null;
  }

  return (
    <DropdownMenuLabel className="p-0 pl-1">
      {listItem.itemCount} {pluralize('item', listItem.itemCount)}{' '}
      {listItem.boardName === BOARDLESS_LOCATION_NAME
        ? listItem.itemCount === 1
          ? 'from another location'
          : 'from other locations'
        : `from ${listItem.boardName} board`}
    </DropdownMenuLabel>
  );
});

SelectedItemGroupHeader.displayName = 'SelectedItemGroupHeader';
